/**
 * Created by XuQiang on 2017/5/23.
 */
import React from 'react';
import LoginDiv from './LoginDiv';
import { FIND_PASSWORD, OPEN_LOGIN, OPEN_SIGN, REST_PASSWORD, SIGN_ACTIVE } from '../../utils/constants';
import RegisterDiv from './RegisterDiv';
import ActivationDiv from './ActivationDiv';
import FindPassword from './FindPassword';
import ResetPassword from './ResetPassword';

export default ({ locale, intl, dispatch,menuData, loginData }) => {
  const { divType } = loginData;
  return (
    <div className="suspension">
      {divType === OPEN_LOGIN && (
        <LoginDiv intl={intl} dispatch={dispatch} menuData={menuData} loginData={loginData} locale={locale} />
      )}
      {divType === OPEN_SIGN && (
        <RegisterDiv intl={intl} dispatch={dispatch} menuData={menuData} loginData={loginData} />
      )}
      {divType === SIGN_ACTIVE && (
        <ActivationDiv intl={intl} dispatch={dispatch} menuData={menuData} loginData={loginData} />
      )}
      {divType === FIND_PASSWORD && (
        <FindPassword intl={intl} dispatch={dispatch} menuData={menuData} loginData={loginData} />
      )}
      {divType === REST_PASSWORD && (
        <ResetPassword intl={intl} dispatch={dispatch} menuData={menuData} loginData={loginData} />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/login/OpenDialogDiv.js